import type { JSX } from "react";

import { useEditorState } from "@tiptap/react";

import { useTextEditorContext } from "./TextEditor.context";
import { readHtml } from "./tools";

export function TextEditorFormValue({ name }: { name: string }): JSX.Element {
  const { editor } = useTextEditorContext();

  const value = useEditorState({
    editor,
    selector: ({ editor }) => (editor === null ? "" : readHtml(editor)),
  });

  return <input type="hidden" name={name} value={value ?? ""} />;
}
